import React, { useState, useEffect } from "react"
import { Redirect } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Grid from "@material-ui/core/Grid"
import { FormControl, InputLabel, MenuItem, Select, Tooltip, Typography } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import Link from "@material-ui/core/Link"

import Header from "../components/Header"
import SideMenu from "../components/menu/SideMenu"
import { CaseList, CreateCase } from "../components/bifrost"
import Modal, { ModalPopup } from "../components/modal"
import UploadFiles from "../components/bifrost/UploadFiles"
import { getCaseListRequest } from "../actions/bifrostActions"
import Notification from "../components/Notification/Notification"
import WithDrawer from "../components/common/drawer/withDrawer"
import { getCharacterCount, getUserloginDetails } from "../actions/billingActions"
import CharCount from "../components/billing/CharCount"
import UserLoginDetails from "../components/billing/UserLoginDetails"
import { getCaseAccessList } from "../actions/usersActions"
import { useTranslation } from "react-i18next"
import BillingFilters from "../components/billing/BillingFilters"
import moment from "moment"

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
	},
	paper: {
		padding: theme.spacing(2),
		color: theme.palette.text.secondary,
	},
	header: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: theme.spacing(2, 0),
		paddingTop: "35px",
	},
	notification: {
		padding: theme.spacing(2, 0),
	},
	headerTitle: {
		...theme.typography.h5,
		paddingBottom: "20px",
	},
	caseSaveMessage: {
		display: "flex",
		alignItems: "center",
	},

	formControl: {
		margin: theme.spacing(1),
		width: 140,
		"& .MuiSelect-icon": {
			color: theme.palette.common.black,
		},
		"& .MuiSelect-outlined": {
			backgroundColor: theme.palette.grey[100],
			borderRadius: "5px",
		},
	},
}))

const PageBilling = () => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [t] = useTranslation("global")

	const { caseList } = useSelector((state) => state.userManagement)
	const userLoginDetails = useSelector((state) => state?.billingReducers?.userLoginDetails)
	const characterCount = useSelector((state) => state?.billingReducers?.characterCount)
	const [caseStatus, setCaseStatus] = useState("")
	const [dateRange, setDateRange] = useState("")
	const [recordsPerPageCharCount, setRecordsPerPageCharCount] = useState(5)
	const [recordsPerPageUserDetails, setRecordsPerPageUserDetails] = useState(5)
	const [pageNumberCharCount, setPageNumberCharCount] = useState(0)
	const [pageNumberUserLoginDetails, setPageNumberUserLoginDetails] = useState(0)

	useEffect(() => {
		const data = {
			case_id: "",
			start_date: "",
			end_date: "",
			return_count: 10,
			skip_count: 0,
		}
		dispatch(getCharacterCount(data))
		dispatch(getUserloginDetails(data))
	}, [])

	useEffect(() => {
		if (_.isEmpty(caseList)) {
			dispatch(getCaseAccessList())
		}
	}, [caseList])

	useEffect(() => {
		const data = {
			case_id: caseStatus?.case_id,
			start_date: dateRange?.startDate ? moment(dateRange?.startDate).format("YYYY-MM-DD") : "",
			end_date: dateRange?.endDate ? moment(dateRange?.endDate).format("YYYY-MM-DD") : "",
			return_count: recordsPerPageCharCount || 5,
			skip_count: 0,
		}
		dispatch(getCharacterCount(data))
	}, [recordsPerPageCharCount])

	useEffect(() => {
		const data = {
			case_id: caseStatus?.project_id,
			start_date: dateRange?.startDate ? moment(dateRange?.startDate).format("YYYY-MM-DD") : "",
			end_date: dateRange?.endDate ? moment(dateRange?.endDate).format("YYYY-MM-DD") : "",
			return_count: recordsPerPageUserDetails,
			skip_count: 0,
		}
		dispatch(getUserloginDetails(data))
	}, [recordsPerPageUserDetails])

	const handleSetCaseStatus = (value) => {
		setCaseStatus(value)
	}

	const handleSetDateRange = (value) => {
		setDateRange(value)
	}

	return (
		<>
			<Grid className={classes.root} container direction="row" data-testid="all_cases_page">
				<Grid container>
					<Grid item xs={12} className={classes.header}>
						<Typography variant="h5" className={classes.headerTitle}>
							{t("billing.billing")}
						</Typography>
					</Grid>
					<BillingFilters
						caseStatus={caseStatus}
						setCaseStatus={handleSetCaseStatus}
						dateRange={dateRange}
						setDateRange={handleSetDateRange}
						recordsPerPageCharCount={recordsPerPageCharCount}
						recordsPerPageUserDetails={recordsPerPageUserDetails}
						setRecordsPerPageCharCount={setRecordsPerPageCharCount}
						setRecordsPerPageUserDetails={setRecordsPerPageUserDetails}
					/>
					<Grid item xs={12}>
						<CharCount
							characterCount={characterCount}
							caseStatus={caseStatus}
							dateRange={dateRange}
							recordsPerPage={recordsPerPageCharCount}
							setRecordsPerPage={setRecordsPerPageCharCount}
							pageNumber={pageNumberCharCount}
							setPageNumber={setPageNumberCharCount}
						/>
					</Grid>
					<Grid item xs={12} style={{ marginTop: "40px" }}>
						<UserLoginDetails
							caseStatus={caseStatus}
							dateRange={dateRange}
							recordsPerPage={recordsPerPageUserDetails}
							setRecordsPerPage={setRecordsPerPageUserDetails}
							pageNumber={pageNumberUserLoginDetails}
							setPageNumber={setPageNumberUserLoginDetails}
							userLoginDetails={userLoginDetails}
						/>
					</Grid>
				</Grid>
			</Grid>
		</>
	)
}

export default WithDrawer(PageBilling)
